import { render } from "./ModalAdditionalEmail.vue?vue&type=template&id=83842384"
import script from "./ModalAdditionalEmail.vue?vue&type=script&lang=js"
export * from "./ModalAdditionalEmail.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__